import React from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { IcIns } from "../common/svg";

import glcare from "../../static/images/landingpage/ins-partner/global-care.jpg";
import mic from "../../static/images/landingpage/ins-partner/mic.jpg";
// import pjico from "../../static/images/landingpage/ins-partner/pjico.png";
import vni from "../../static/images/landingpage/ins-partner/vni.jpg";
import pvi from "../../static/images/landingpage/ins-partner/pvi.jpg";

const InsuranceWD = ({ show, onHide }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-l modal-fix modal-text modal-ins-landingpage">
			<Modal.Header closeButton={true} closeLabel={""} />
			<Modal.Body>
				<div className="modal-text-body modal-ins-landingpage-body">
					<div className="ins-landing-inner">
						<h5>Bảo hiểm thuê&nbsp;xe</h5>
						<p>An tâm hơn với gói bảo hiểm Phúc Bình An dành riêng các hành trình thuê xe có tài xế trên Mioto!</p>
					</div>
					<div className="block-content">
						<p className="body-title">I. NỘI DUNG SẢN PHẨM BẢO HIỂM PHÚC BÌNH AN</p>
						<p>Trong thời gian thuê xe, khách thuê &amp; tài xế được bảo vệ nếu xảy ra các sự cố ngoài ý muốn sau:</p>
						<p>1. Thiệt hại thân thể đối với lái xe và những người được chở trên xe.</p>
						<p>2. Thiệt hại về người và tài sản của bên thứ ba.</p>
					</div>
					<div className="block-content">
						<p className="body-title">II. Điều khoản Bảo hiểm</p>
						<ul className="number-ul">
							<li>Bảo hiểm con người: tối đa 200 triệu/người/vụ</li>
							<p className="font-14 note">* Phí y tế điều trị nội trú: 200k/ngày, tối đa 180 ngày/năm</p>
							<li>Bảo hiểm TNDS tự nguyện: tối đa 300 triệu/vụ</li>
						</ul>
					</div>
					<div className="block-content">
						<p className="body-title">III. GIẢI ĐÁP THẮC MẮC QUYỀN LỢI BẢO HIỂM</p>
						<p>
							Tổng đài GLOBAL CARE giải đáp thắc mắc quyền lợi bảo hiểm: <strong>1900 292 987</strong>
						</p>
					</div>
					<div className="block-content">
						<p className="body-title">IV. HỖ TRỢ GIẢI QUYẾT SỰ CỐ</p>
						<p>Nếu xảy ra sự cố, vui lòng:</p>
						<p>
							<strong>TH không có va chạm bên thứ 3</strong>
						</p>
						<ul className="number-ul">
							<li>Sơ cứu người bị thương hoặc gọi cấp cứu 115.</li>
							<li>Chụp ảnh hiện trường.</li>
							<li>
								Thông báo cho Bảo hiểm PVI theo số <strong>1900 54 54 58</strong> & làm theo hướng dẫn tổng đài.
							</li>
							<li>Nộp hồ sơ yêu cầu bồi thường, gồm:</li>
						</ul>
						<ul className="disc-ul">
							<li>Bản sao giấy tờ xe (cavet, đăng kiểm, bằng lái xe)</li>
							<li>Đơn yêu cầu bồi thường (theo mẫu của PVI)</li>
							<li>Hồ sơ điều trị & chứng từ thanh toán.</li>
						</ul>
						<p>TH có va chạm bên thứ 3</p>
						<ul className="number-ul">
							<li>Sơ cứu người bị thương hoặc gọi cấp cứu 115.</li>
							<li>Chụp ảnh hiện trường & thông báo đến cơ quan CA gần nhất.</li>
							<li>
								Thông báo cho Bảo hiểm PVI theo số <strong>1900 54 54 58</strong> & làm theo hướng dẫn tổng đài.
							</li>
							<li>Nộp hồ sơ yêu cầu bồi thường, gồm:</li>
						</ul>
						<ul className="disc-ul">
							<li>Bản sao giấy tờ xe (cavet, đăng kiểm, bằng lái xe)</li>
							<li>Đơn yêu cầu bồi thường (theo mẫu của PVI)</li>
							<li>Hồ sơ TNGT của Cơ quan CA (nếu sự cố có thiệt hại ước tính {">"}10tr)</li>
							<li>Hồ sơ điều trị & chứng từ thanh toán.</li>
						</ul>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export const InsuranceBox = (props) => {
	return (
		<Modal show={props.show} onHide={props.onHide} dialogClassName="modal-l modal-fix modal-text modal-ins-landingpage">
			<Modal.Header closeButton={true} closeLabel={""} />
			<Modal.Body>
				<div className="modal-text-body modal-ins-landingpage-body">
					<div className="ins-landing-inner">
						<h5>Bảo hiểm thuê xe tự&nbsp;lái</h5>
						<p>
							Với nhiều năm kinh nghiệm trong lĩnh vực cho thuê xe tự lái, Mioto hiểu rằng các rủi ro đâm đụng, cháy nổ,
							thủy kích gây tổn thất lớn (vượt quá khả năng chi trả) luôn tiềm ẩn trong thời gian thuê xe.
						</p>
						<p>
							❌ Trong khi đó, hầu hết các rủi ro phát sinh trong quá trình thuê xe tự lái sẽ{" "}
							<u className="fontWeight-8">không thuộc phạm vi</u> của
							<b> Bảo hiểm thân vỏ xe theo năm</b> (hay còn gọi là Bảo hiểm 2 chiều).
						</p>
						<p>
							✅ Xuất phát từ nhu cầu thiết yếu của khách hàng, Mioto kết hợp với
							<b> Bảo hiểm MIC, VNI & Global Care </b>
							cùng mang đến sản phẩm <b>Bảo hiểm thuê xe ô tô tự lái</b>, đầu tiên tại Việt Nam, và hiện chỉ có tại
							Mioto với mức phí thực sự tiết kiệm và số tiền bảo hiểm lớn (đến 100% giá trị xe) sẽ giúp bạn không còn lo
							lắng khi thuê xe & an tâm tận hưởng hành trình của mình.
						</p>
					</div>
					<div className="block-content">
						<p className="body-title">I. Nội dung sản phẩm Bảo hiểm thuê xe</p>
						<p>
							Trong thời gian thuê xe, nếu xảy ra các sự cố va chạm ngoài ý muốn dẫn đến tổn thất về xe, khách thuê sẽ
							chỉ bồi thường số tiền tối đa <span>2,000,000đ </span>để sửa chữa xe (mức khấu trừ), nhà bảo hiểm sẽ hỗ
							trợ cho các chi phí phát sinh vượt mức khấu trừ.
						</p>
						<table>
							<tbody>
								<tr>
									<td>
										<p>Thiệt hại xe</p>
									</td>
									<td>
										<p>Khách thanh toán</p>
									</td>
									<td>
										<p>Bảo hiểm thanh toán</p>
									</td>
								</tr>
								<tr>
									<td>
										<p>&lt;= 2 triệu</p>
									</td>
									<td>
										<p>&lt;= 2 triệu</p>
									</td>
									<td>
										<p>0 triệu</p>
									</td>
								</tr>
								<tr>
									<td>
										<p>&gt;2 triệu</p>
									</td>
									<td>
										<p>2 triệu</p>
									</td>
									<td>
										<p>298 triệu</p>
									</td>
								</tr>
								<tr>
									<td colSpan={3}>
										<p>
											<i>Ví dụ minh họa:</i> Xe có sự cố tổn thất 300,000,000đ
										</p>
									</td>
								</tr>
							</tbody>
						</table>
						<p>
							• Lưu ý: Khách hàng cần thực hiện đầy đủ <strong>Quy trình xử lý</strong> khi xảy ra sự cố (
							<strong>Mục III</strong> bên dưới).
						</p>
					</div>
					<div className="block-content">
						<p className="body-title">II. Điều khoản Bảo hiểm</p>
						<ul className="disc-ul">
							<li>Bảo hiểm vật chất xe: đâm va , hỏa hoạn, cháy nổ</li>
							<li>Miễn phí cứu hộ tối đa 70km/vụ</li>
							<li>Bảo hiểm thủy kích (khấu trừ 20% số tiền bảo hiểm, tối thiểu 3 triệu đồng)</li>
							<li>Mức khấu trừ: 2,000,000đ/vụ</li>
						</ul>
						<p className="font-14 note">
							• Giải thích <strong>Mức khấu trừ</strong>: mọi sự cố ngoài ý muốn trong phạm vi bảo hiểm, số tiền tối đa
							khách thuê thanh toán là <u>2&nbsp;triệu&nbsp;đồng</u>, chưa bao gồm:
						</p>
						<p className="font-14 note">- Giảm trừ bồi thường/chế tài theo Quy tắc của Nhà bảo hiểm,</p>
						<p className="font-14 note">- Thiệt hại do xe không cho thuê được trong thời gian sửa chữa nếu có,</p>
						<p className="font-14 note">- Các lí do chủ quan khác nằm ngoài phạm vi bảo hiểm.</p>
						<p className="font-14 note">
							<i>
								Quy tắc bảo hiểm MIC: Xem thêm tại
								<a
									className="font-14 note fontWeight-8"
									href="https://n1-cstg.mioto.vn/m/insurance/Quy-tac-MIC.pdf"
									target="_blank">
									{" "}
									<u>liên kết</u>
								</a>
							</i>
						</p>
						<p className="font-14 note">
							<i>
								Quy tắc bảo hiểm VNI: Xem thêm tại
								<a
									className="font-14 note fontWeight-8"
									href="https://n1-cstg.mioto.vn/m/insurance/Quy-tac-VNI.pdf"
									target="_blank">
									{" "}
									<u>liên kết</u>
								</a>
							</i>
						</p>
					</div>
					<div className="block-content">
						<p className="body-title">III. Quy trình xử lí nếu xảy ra sự cố</p>
						<ul className="number-ul">
							<li>Khách thuê chụp ảnh hiện trường.</li>
							<li>
								Khách thuê gọi đến trung tâm bồi thường của nhà bảo hiểm (MIC - 1900 55 88 91) (VNI - 0937 393 955), đọc
								số hợp đồng bảo hiểm và làm theo hướng dẫn tổng đài.
							</li>
							<li>
								Giám định viên bảo hiểm liên hệ khách thuê để hướng dẫn xử lí, xác minh thông tin và xác minh hiện
								trường (nếu có).
							</li>
							<li>
								Giám định viên và chủ xe/khách thuê cùng mang xe ra Garage để giám định thiệt hại và ra
								<span> Báo giá sửa chữa.</span>
							</li>
							<li>
								Trung tâm bồi thường của nhà bảo hiểm ra <span>Biên bản giám định thiệt hại.</span>
							</li>
							<li>Garage tiến hành sửa chữa theo báo giá.</li>
						</ul>
					</div>
					<div className="block-content">
						<p className="body-title">IV. Hướng dẫn chọn xe có Bảo hiểm thuê xe</p>
						<ul className="number-ul">
							<li>
								Các xe có hỗ trợ dịch vụ bảo hiểm sẽ có logo <strong>Bảo hiểm thuê xe </strong>
								<span className="wrap-svg position-relative" style={{ bottom: "-6px" }}>
									<IcIns />
								</span>
								tại ảnh đại diện của xe.
							</li>
							{/* <li>
								Quý khách hàng có thể thay đổi lựa chọn dịch vụ của 1 trong 2 nhà bảo hiểm MIC/PJICO tùy theo nhu cầu
								tại mục <span>Bảo hiểm </span>ở bước đặt xe.
							</li> */}
						</ul>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

class Insurance extends React.Component {
	constructor() {
		super();

		this.state = {
			isShowInsBox: false,
			isShowWDInsBox: false,
		};
	}

	toggleInsBox = () => {
		this.setState({
			isShowInsBox: !this.state.isShowInsBox,
		});
	};

	toggleWDInsBox = () => {
		this.setState({
			isShowWDInsBox: !this.state.isShowWDInsBox,
		});
	};
	render() {
		const { isShowInsBox, isShowWDInsBox } = this.state;
		return (
			<div className="ins-partner-section space sec">
				<div className="m-container">
					<h2>Hành Trình Của Bạn Luôn Được Bảo Vệ</h2>
				</div>
				<div className="m-container">
					<Swiper
						slidesPerView={1}
						spaceBetween={10}
						modules={[Pagination]}
						className="swiper-insurance"
						pagination={{
							el: ".pagi-insurance",
							clickable: true,
							dynamicBullets: true,
						}}
						breakpoints={{
							1200: {
								slidesPerView: 4,
								spaceBetween: 32,
							},
							768: {
								slidesPerView: 3,
								spaceBetween: 20,
							},
							577: {
								slidesPerView: 2,
							},
							481: {
								slidesPerView: 1.5,
							},
						}}>
						<SwiperSlide onClick={this.toggleInsBox}>
							<img loading="lazy" src={glcare} />
						</SwiperSlide>
						<SwiperSlide onClick={this.toggleInsBox}>
							<img loading="lazy" src={mic} />
						</SwiperSlide>
						<SwiperSlide onClick={this.toggleInsBox}>
							<img loading="lazy" src={vni} />
						</SwiperSlide>
						<SwiperSlide onClick={this.toggleWDInsBox}>
							<img loading="lazy" src={pvi} />
						</SwiperSlide>
						<div className="swiper-pagination pagi-insurance" />
					</Swiper>
				</div>
				<InsuranceBox show={isShowInsBox} onHide={this.toggleInsBox} />
				<InsuranceWD show={isShowWDInsBox} onHide={this.toggleWDInsBox} />
			</div>
		);
	}
}

export default Insurance;
